import { Component, Vue, Prop } from 'vue-property-decorator'
import { getSchoolList } from '@/api/common'

@Component({
  directives: {
    'el-select-loadmore': {
      // bind表示这个自定义指令一绑定到dom上，就开始自动执行
      bind(el: any, binding: any) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
          * scrollHeight 获取元素内容高度(只读)
          * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
          * clientHeight 读取元素的可见高度(只读)
          * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
          * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
          */
          console.log(el.scrollHeight, el.scrollTop, el.clientHeight)
          //    this.scrollHeight = el.scrollHeight
          //    this.scrollTop = el.scrollTop
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      },
      // 表示dom插入到页面上的时候自动执行
      // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
      inserted(el, binding) {
        el.focus()
      },
      // 表示自定义指令后面的值更新的时候，自动执行
      update() {
        console.log(this.scrollHeight, this.scrollTop, '11');
      }
    }
  }
})
export default class SelectSchool extends Vue {

  @Prop() attendSchool: string;

  allPage = 0
  page = 1
  name = ''
  schoolList = []
  schoolId: number = null

  mounted() {
    this.getSchoolList()
  }

  async getSchoolList() {
    const data: any = await getSchoolList({ page: this.page, name: this.name })
    this.allPage = data.allNum / 20
    this.schoolList = [...this.schoolList, ...data.schoolList]
  }
  changeSchool(e) {
    const schoolItem = this.schoolList.filter(item => item.name === e)[0]
    this.$emit('changeSchool', ( schoolItem || { name: e }) )
  }
  clearSchool() {
    this.schoolId = null
  }
  loadmore() {
    this.page++
    this.getSchoolList();
  }
  async remoteMethod(query: any) {
    this.name = query
    this.page = 1
    if (query !== '') {
      const result: any = await getSchoolList({ page: this.page, name: query })
      this.schoolList = result.schoolList
    } else {
      this.schoolList = []
    }
  }
}